(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  function on(root, selector, event, handler) {
    root.addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target && root.contains(target)) handler(target, e);
    });
  }

  /* ---------------- Mood finder (03) ---------------- */
  document.querySelectorAll("[data-mood-finder]").forEach(function (root) {
    on(root, "[data-mood-btn]", "click", function (btn) {
      var mood = btn.getAttribute("data-mood");
      root.querySelectorAll("[data-mood-btn]").forEach(function (b) {
        b.setAttribute("aria-pressed", String(b === btn));
      });
      root.querySelectorAll("[data-mood-why]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-mood-why") === mood);
      });
      root.querySelectorAll("[data-mood-recs]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-mood-recs") === mood);
      });
    });
  });

  /* ---------------- Lighting comparison (04) ---------------- */
  document.querySelectorAll("[data-compare]").forEach(function (root) {
    on(root, "[data-light-btn]", "click", function (btn) {
      var light = btn.getAttribute("data-light");
      root.querySelectorAll("[data-light-btn]").forEach(function (b) {
        b.setAttribute("aria-pressed", String(b === btn));
      });
      root.querySelectorAll(".cl-compare-cell[data-light]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-light") === light);
      });
      root.querySelectorAll(".cl-compare-note__text[data-light]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-light") === light);
      });
    });
  });

  /* ---------------- Set builder (08) + sticky CTA sync ---------------- */
  var MAX_PICKS = 3;
  var picks = [];
  /* 같은 컬러를 여러 개 담을 수 있게 수량은 버튼의 data-qty 에 둡니다.
     도수는 컬러당 하나이므로 수량 2 는 같은 도수 2개로 들어갑니다. */
  /* 팩 수는 도수 줄의 개수입니다. 같은 컬러에 도수 줄을 여러 개 만들 수 있어서
     컬러 개수로 세면 맞지 않습니다. */
  function powerRows() {
    return [].slice.call(document.querySelectorAll('[data-set-powers] [data-power-row] select'));
  }
  function pickedTotal() {
    return powerRows().length;
  }

  function formatPrice(n) {
    return n.toLocaleString("ko-KR") + "원";
  }

  function computeTotal(unitPrice) {
    var n = pickedTotal();
    if (n === 0) return "—";
    /* 3개 묶음마다 1개 무료 = 묶음당 2개 값, 남는 수량은 정가. n=3 이면 기존과 동일.
       실제 할인은 결제 단계에서 적용되므로 이 숫자는 안내용입니다. */
    if (n >= MAX_PICKS) {
      var sets = Math.floor(n / MAX_PICKS);
      return formatPrice(unitPrice * (sets * (MAX_PICKS - 1) + (n % MAX_PICKS)));
    }
    return formatPrice(unitPrice * n);
  }

  function broadcast(promoLabel, unitPrice) {
    var n = pickedTotal();
    var detail = {
      count: n,
      total: computeTotal(unitPrice),
      countText: n >= MAX_PICKS
        ? n + " selected · " + Math.floor(n / MAX_PICKS) + " free"
        : n + " / " + MAX_PICKS + " selected",
      stickyNote: n === 0 ? promoLabel : n + " selected"
    };
    document.dispatchEvent(new CustomEvent("eeys:set:update", { detail: detail }));
  }

  function getPickedVariantIds() {
        /* 도수 줄의 select 값을 모아 같은 variant 는 수량으로 합칩니다. */
        var order = [];
        var qty = {};
        powerRows().forEach(function (sel) {
          var id = sel.value;
          if (!id) return;
          if (!qty[id]) { qty[id] = 0; order.push(id); }
          qty[id] += 1;
        });
        return order.map(function (id) { return { id: id, quantity: qty[id] }; });
      }

      function addToCart(cartUrl, onDone) {
    var ids = getPickedVariantIds();
    if (!ids.length) {
      onDone(new Error("no linked products"));
      return;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: ids
      })
    })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function () { onDone(null); })
      .catch(function (err) { onDone(err); });
  }

  document.querySelectorAll("[data-set-builder]").forEach(function (root) {
    var unitPrice = parseInt(root.getAttribute("data-unit-price"), 10) || 0;
    var promoLabel = root.getAttribute("data-promo-label") || "";

    function render() {
      root.querySelectorAll("[data-set-btn]").forEach(function (btn) {
        var selected = picks.indexOf(btn.getAttribute("data-color-key")) >= 0;
        btn.setAttribute("aria-pressed", String(selected));
        var label = btn.querySelector("[data-pick-label]");
        if (label) label.textContent = selected ? "Selected" : "Select";
      });
      var countEl = root.querySelector("[data-set-count]");
      var totalEl = root.querySelectorAll("[data-set-total]");
      var n = pickedTotal();
      if (countEl) {
        countEl.textContent = n >= MAX_PICKS
          ? n + " selected · " + Math.floor(n / MAX_PICKS) + " free"
          : n + " / " + MAX_PICKS + " selected";
      }
      totalEl.forEach(function (el) { el.textContent = computeTotal(unitPrice); });
      broadcast(promoLabel, unitPrice);
    }

    /* 수량 스테퍼가 data-qty 를 바꾼 뒤 합계·라벨을 다시 계산하도록 여는 창구입니다. */
    document.addEventListener("eeys:set:qty", function () { render(); });

    on(root, "[data-set-btn]", "click", function (btn) {
      var key = btn.getAttribute("data-color-key");
      var idx = picks.indexOf(key);
      if (idx >= 0) {
        picks.splice(idx, 1);
      } else {
        picks.push(key);
      }
      render();
    });

    render();
  });

  document.querySelectorAll("[data-sticky-cta]").forEach(function (root) {
    var noteEl = root.querySelector("[data-sticky-note]");
    var totalEl = root.querySelector("[data-sticky-total]");
    var button = root.querySelector("[data-sticky-button]");
    var defaultNote = noteEl ? noteEl.textContent : "";
    var hasPicks = false;

    document.addEventListener("eeys:set:update", function (e) {
      if (noteEl) noteEl.textContent = e.detail.stickyNote || defaultNote;
      if (totalEl) totalEl.textContent = e.detail.total;
      hasPicks = e.detail.count > 0;
      if (button) {
        button.textContent = hasPicks
          ? button.getAttribute("data-cart-label")
          : button.getAttribute("data-browse-label");
      }
    });

    if (button) {
      button.addEventListener("click", function () {
        if (!hasPicks) {
          var targetSel = button.getAttribute("data-scroll-target");
          var targetEl = targetSel && document.querySelector(targetSel);
          if (targetEl) targetEl.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        var cartUrl = button.getAttribute("data-cart-url") || "/cart";
        button.disabled = true;
        addToCart(cartUrl, function (err) {
          button.disabled = false;
          if (err) {
            console.error("[color-landing] add to cart failed:", err);
            return;
          }
          window.location.href = cartUrl;
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
